import Box from '../../Box/Box';
import SuccessCheck from '../../icons/SuccessCheck';
import { useTranslation } from 'react-i18next';

const SuccessReservation = () => {
  const { t } = useTranslation();

  return (
    <>
      <Box>
        <div className='d-flex justify-content-center'>
          <SuccessCheck color='var(--color-primary)' size={200} />
        </div>
        <div className='mt-5'>
          <div className='font-125 fw-600 mb-2'>{t('requestSent')}</div>
          <div className='text-secondary font-small mb-2'>{t('processingRequest')}</div>
        </div>
      </Box>
    </>
  );
};

export default SuccessReservation;
